var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorwayOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 7.8h10c.11 0 .2.09.2.2v16a.2.2 0 0 1-.2.2H11a.2.2 0 0 1-.2-.2v-6.182L9 17.81V24a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2v6.177l1.8-.008V8c0-.11.09-.2.2-.2z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.26 16.592 3.213 3.15c.179.144.41.258.601.258.474 0 .82-.36.82-.829a.831.831 0 0 0-.256-.575L5.28 17.282l-.537-.486 7.45.029c.461 0 .807-.36.807-.83 0-.485-.346-.832-.807-.832l-7.45.029.538-.486 1.37-1.326a.818.818 0 0 0 .243-.576c0-.47-.333-.804-.82-.804a.956.956 0 0 0-.601.245L2.26 15.384a.833.833 0 0 0 0 1.208z",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.22a1 1 0 0 1 1.196-.98l8 1.6a1 1 0 0 1 .804.98v20.36a1 1 0 0 1-.804.98l-8 1.6A1 1 0 0 1 15 27.78z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorwayOut);
export default __webpack_public_path__ + "static/media/Doorway-Out.df4b10b1c809a980a956cd729c3be224.svg";
export { ForwardRef as ReactComponent };